import { Button, Form, Offcanvas } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { CatalogCategoryFilter } from 'modules/product';
import {
    defaultStockControlFilter,
    type StockControlFilter,
} from '../model/stockControlFiltersStorage';

interface OffStockControlFilterProps {
    show: boolean;
    setShow: (show: boolean) => void;
    prevFilter: StockControlFilter;
    setPrevFilter: (filter: StockControlFilter) => void;
    onApply: (filter: StockControlFilter) => void;
}

const OffStockControlFilter = ({
    show,
    setShow,
    prevFilter,
    setPrevFilter,
    onApply,
}: OffStockControlFilterProps) => {
    const { t } = useTranslation(['Warehouses', 'common']);

    const setKind = (key: keyof Omit<StockControlFilter, 'categoryIds'>, checked: boolean) => {
        setPrevFilter({ ...prevFilter, [key]: checked });
    };

    return (
        <Offcanvas show={show} onHide={() => setShow(false)} placement="end">
            <Offcanvas.Header closeButton className="border-bottom">
                <Offcanvas.Title>{t('filter.title')}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="position-relative pb-0 d-flex flex-column px-0">
                <div className="off-filter-form d-flex flex-column h-100">
                    <div className="off-filter-content px-3">
                        <CatalogCategoryFilter
                            embedded
                            kind="product"
                            filterCategoryIds={prevFilter.categoryIds}
                            setFilterCategoryIds={(ids) => setPrevFilter({ ...prevFilter, categoryIds: ids })}
                        />

                        <Form.Group className="mb-3">
                            <Form.Check
                                className="mb-2"
                                type="switch"
                                id="stock-control-main"
                                label={t('stockControl.filter.main')}
                                checked={prevFilter.includeMain}
                                onChange={(e) => setKind('includeMain', e.target.checked)}
                            />
                            <Form.Check
                                className="mb-2"
                                type="switch"
                                id="stock-control-custom"
                                label={t('stockControl.filter.custom')}
                                checked={prevFilter.includeCustom}
                                onChange={(e) => setKind('includeCustom', e.target.checked)}
                            />
                            <Form.Check
                                className="mb-2"
                                type="switch"
                                id="stock-control-team"
                                label={t('stockControl.filter.team')}
                                checked={prevFilter.includeTeam}
                                onChange={(e) => setKind('includeTeam', e.target.checked)}
                            />
                            <Form.Check
                                className="mb-2"
                                type="switch"
                                id="stock-control-reserve"
                                label={t('stockControl.filter.reserve')}
                                checked={prevFilter.includeReserve}
                                onChange={(e) => setKind('includeReserve', e.target.checked)}
                            />
                        </Form.Group>
                    </div>

                    <div className="p-3 offcanvas-footer off-filter-footer">
                        <div className="d-flex justify-content-end gap-2">
                            <Button
                                variant="secondary"
                                onClick={() => {
                                    const next = defaultStockControlFilter();
                                    setPrevFilter(next);
                                    onApply(next);
                                    setShow(false);
                                }}
                            >
                                {t('common:buttons.reset')}
                            </Button>
                            <Button
                                variant="info"
                                className="min100px"
                                onClick={() => {
                                    onApply(prevFilter);
                                    setShow(false);
                                }}
                            >
                                {t('common:buttons.apply')}
                            </Button>
                        </div>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default OffStockControlFilter;
